// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    teams_find_teams: 'Buscando entre las cuadrillas',
    teams_team_detail: 'Leyendo la cuadrilla',
    teams_who_is_with: 'Mirando con quién vas',
  },
  ca: {
    teams_find_teams: 'Cercant entre les colles',
    teams_team_detail: 'Llegint la colla',
    teams_who_is_with: 'Mirant amb qui vas',
  },
  en: {
    teams_find_teams: 'Looking through the crews',
    teams_team_detail: 'Reading the crew',
    teams_who_is_with: 'Working out who you are going with',
  },
  fr: {
    teams_find_teams: 'Recherche parmi les équipes',
    teams_team_detail: 'Lecture de l’équipe',
    teams_who_is_with: 'Recherche de vos coéquipiers',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
